
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/investor-charter",
      function () {
        return require("private-next-pages/investor-charter/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/investor-charter"])
      });
    }
  